(function () {'use strict';}());
angular.module("elidb").directive('map', function($document,$timeout) {
    return {
      restrict: 'A',

      link:function($scope,element,attr)
      {
        var trace = angular.trace; 
        var openWindow;

        $scope.$watch("results",initialize);

        function initialize(val)
        {
        	if(!window.$) return setTimeout(function(){ initialize(val); }, 500);
        	if(!val) return;
        	if(!window.google) return trace("no google map library found");
        	$timeout(function(){
        			var myLatLng = {lat: $scope.latitude, lng: $scope.longitude};
			var map = new google.maps.Map(element.find("#map-container").get(0), {
				zoom: 10,
				center: myLatLng
			});

			angular.forEach($scope.results,function(resource){
				var position = {lat:resource.latitude,lng:resource.longitude};
//				trace(resource);
				//if(!position.lat || !position.lng || !$scope.refined) return;
				if(!position.lat || !position.lng || resource.statewide === "true") return;
				
				var infowindow = new google.maps.InfoWindow({
				    content: resource.name + "<br/>" + resource.street + "<br/>" + resource.city + ", " + resource.state + "<br/>" + resource.zip
				  });
				var marker = new google.maps.Marker({
					position: position,
					map: map,
					title: resource.name,
				});
				trace(window.$, window.jQuery);

				var target = $("#search-result-"+resource.id);



				marker.addListener('click', function() {
					var block = target;
					var parent = $("div.results");
					var offset = block.offset().top - parent.offset().top + parent.get(0).scrollTop - 112;
					if(openWindow) openWindow.close();
					openWindow = infowindow;
				    infowindow.open(map, marker);
				    parent.animate({scrollTop:offset},1000);
				  });

				if(!$scope.mobile){
					target.hover(function() {
						var block = target;
						var parent = block.parent();
						if(openWindow) openWindow.close();
						openWindow = infowindow;
					    infowindow.open(map, marker);
					  });
				}


			});

        	},0);
        	
			
        }
      }  
    };
  });